import * as React from "react";
import { PartnerFormContextBody } from "./types";

export const PartnerFormContext = React.createContext<PartnerFormContextBody>({
  loading: false,
  updateFormValues: () => {},
  push: () => {},
});
